import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import * as CourseActions from '../../shared/core/state/course/course.actions';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import {
  CourseItem,
  CourseStatus,
} from '../../shared/core/state/course/models';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FormatterService } from '../../shared/util/formatter.service';
import { toCourseCardViewModel } from '../../shared/util/ui-card.mapper';
import { UiCardViewModel } from '@black/ui';
import { TenantService } from '../../shared/services/tenant.service';

@Component({
  selector: 'black-add-course-success',
  templateUrl: './add-course-success.component.html',
  styleUrls: ['./add-course-success.component.css'],
  standalone: false,
})
export class AddCourseSuccessComponent implements OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private formatter = inject(FormatterService);
  private tenantService = inject(TenantService);

  createdCourseItem: CourseItem | null = null;
  createdCourseCard: UiCardViewModel | null = null;
  isAutoPublishEnabled = false;

  onDestroy$ = new Subject();

  ngOnInit(): void {
    this.tenantService.currentTenant$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((tenant) => {
        this.isAutoPublishEnabled =
          tenant?.settings?.features?.autoPublishLiveClasses !== false;
      });

    this.store
      .select((store) => store.courses.createdCourseItem)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((item) => {
        this.createdCourseItem = item;
        this.createdCourseCard = item
          ? toCourseCardViewModel(item, this.formatter)
          : null;

        if (
          item?.status === CourseStatus.UNDER_REVIEW ||
          item?.status === CourseStatus.PUBLISHED
        ) {
          this.router.navigate(['/dashboard/courses']);
        }
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next('');
  }

  submitForReview() {
    if (this.createdCourseItem) {
      this.store.dispatch(
        CourseActions.requestForReview({
          courseId: this.createdCourseItem._id,
        })
      );
    }
  }

  publishCourse() {
    if (this.createdCourseItem) {
      this.store.dispatch(
        CourseActions.publishCourse({
          courseId: this.createdCourseItem._id,
        })
      );
    }
  }
}
